module.exports = __webpack_public_path__ + "static/media/nodata_department.e25d6d46.png";